// extracted by mini-css-extract-plugin
export default {"wrapper":"ModalAddVariant_wrapper__9LIaA","head":"ModalAddVariant_head__geUwp","content":"ModalAddVariant_content__NJtqW"};